import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-google-button',
  standalone: true,
  templateUrl: './google-button.component.html',
  styleUrl: './google-button.component.scss',
})
export class GoogleButtonComponent {
  label = input.required<string>();
  btnClick = output<void>();
}
